import script from "./HistogramSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./HistogramSlider.vue?vue&type=script&setup=true&lang=js"

import "./HistogramSlider.vue?vue&type=style&index=0&id=377bbb24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377bbb24"]])

export default __exports__